var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-overlay',{attrs:{"show":_vm.show,"z-index":999999}},[_c('div',{staticClass:"wrapper"},[_c('van-loading',{attrs:{"type":"spinner"}}),_c('div',{staticClass:"font mt-1",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t(_vm.title)))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }